import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainLayout from "./components/layout/MainLayout";
import Home from "./pages/Home";
import Permise from "./pages/Permise";
import Examinari from "./pages/Examinari";
import Inmatriculari from "./pages/Inmatriculari";
import Rezervari from "./pages/Rezervari";
import Program from "./pages/Program";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import Noutati from "./pages/Noutati";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainLayout />}>
            <Route index element={<Home />} />
            <Route path="permise" element={<Permise />} />
            <Route path="examinari" element={<Examinari />} />
            <Route path="inmatriculari" element={<Inmatriculari />} />
            <Route path="rezervari" element={<Rezervari />} />
            <Route path="program" element={<Program />} />
            <Route path="contact" element={<Contact />} />
            <Route path="noutati" element={<Noutati />} />
            <Route path="admin" element={<Admin />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
